import { api } from '../../core/network/api';

/**
 * Thin REST wrapper for the current Mars season — its own file rather than
 * folded into profile-api.ts, which is deliberately scoped to the one
 * identity endpoint the profile screen owns (see that file's doc comment).
 */

export type SeasonStatus = 'UPCOMING' | 'ACTIVE' | 'ENDED';

export interface Season {
  id: string;
  name: string;
  number: number;
  startsAt: string;
  endsAt: string;
  status: SeasonStatus;
}

export interface SeasonCurrentView {
  season: Season;
  /** Live, summed across the caller's whole colony portfolio — 0 if they have no colony yet. */
  colonySeasonPoints: number;
}

/** GET /season/current — the active 3-month season, plus the caller's live standing in it. */
export function fetchCurrentSeason(): Promise<SeasonCurrentView> {
  return api.get<SeasonCurrentView>('/season/current');
}
